<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div [formGroup]="dataForm" class="form-background">
	<div class="header-mat-card-padding">
		<mat-card class="header-width-pixels form-card">
			<mat-card-content>
				<div class="flex-layout-row flex-layout-align-space-between-center">
					<div class="flex-layout-row flex-layout-gap-20px name-input">
						<mat-form-field class="flex-layout-align-center">
							<mat-label>Name</mat-label>
							<input formControlName="name" matInput tabIndex="1" />
							<mat-error *ngIf="name.touched && name.errors?.required"> Name is required </mat-error>
							<mat-error *ngIf="name.touched && name.errors?.maxlength"> Name must be no more than 200 characters </mat-error>
						</mat-form-field>
					</div>
					<div class="flex-layout-gap-10px button-bottom-padding">
						<!-- tab index here needs to include the 12 values inside the social media list component	 -->
						<button mat-raised-button (click)="save()" color="primary" tabIndex="26">{{ saveText }}</button>
						<button mat-raised-button (click)="cancel()" tabIndex="27">Cancel</button>
					</div>
				</div>
				<concurrency-error [message]="concurrencyErrorMessage" (reloadRequested)="loadFormDetails()"></concurrency-error>
			</mat-card-content>
		</mat-card>
	</div>

	<div class="flex-layout-row design-form__content">
		<div class="form-width-pixels form-mat-card-padding">
			<mat-card class="main-card">
				<mat-card-content>
					<div class="pseudo-form-field flex-layout-column">
						<mat-label class="display-label">Image</mat-label>
						<image-selector formControlName="image" accept="image/png, image/jpeg" (isValid)="setImageIsValid($event)" (invalidErrorType)="setImageValidationMessage($event)" (fileSelected)="setImageFileName([$event])" [startTabIndex]="2"></image-selector>
						<pseudo-form-field-error [errorMessage]="imageErrorMessage()" [showError]="showImageError()"> </pseudo-form-field-error>
					</div>

					<div>
						<mat-form-field>
							<mat-label>Email Subject</mat-label>
							<input formControlName="emailSubject" matInput tabIndex="4" />
							<mat-error *ngIf="emailSubject.touched && emailSubject.errors?.required"> Email Subject is required </mat-error>
							<mat-error *ngIf="emailSubject.touched && emailSubject.errors?.maxlength"> Email Subject must be no more than 200 characters </mat-error>
						</mat-form-field>
					</div>

					<div class="pseudo-form-field">
						<mat-label class="no-formfield">Email Body</mat-label>
						<!-- tab index is set in the ngOnInit -->
						<editor formControlName="emailBody" apiKey="{{ tinyMceApiKey }}" [init]="tinyMceSettings" (onInit)="mceOnInit()"></editor>
						<pseudo-form-field-error [errorMessage]="'Email Body is required'" [showError]="emailBody.touched && emailBody.errors?.required"> </pseudo-form-field-error>
					</div>

					<div class="flex-layout-row flex-layout-align-space-between-center">
						<div class="flex-layout-column">
							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center flex-layout-gap-20px">
									<mat-label class="no-formfield">Background Colour</mat-label>
									<colour-picker formControlName="backgroundColour" [startTabIndex]="6"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center flex-layout-gap-20px">
									<mat-label class="no-formfield">Text Colour</mat-label>
									<colour-picker formControlName="textColour" [startTabIndex]="8"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center flex-layout-gap-20px">
									<mat-label class="no-formfield">Links Colour</mat-label>
									<colour-picker formControlName="linksColour" [startTabIndex]="10"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center flex-layout-gap-20px">
									<mat-label class="no-formfield">Heading Background Colour</mat-label>
									<colour-picker formControlName="headingBackgroundColour" [startTabIndex]="12"></colour-picker>
								</div>
							</div>
						</div>
						<div class="flex-layout-column">
							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center flex-layout-gap-20px">
									<mat-label class="no-formfield">Heading Text Colour</mat-label>
									<colour-picker formControlName="headingTextColour" [startTabIndex]="7"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center flex-layout-gap-20px">
									<mat-label class="no-formfield">Subheading Background Colour</mat-label>
									<colour-picker formControlName="subheadingBackgroundColour" [startTabIndex]="9"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center flex-layout-gap-20px">
									<mat-label class="no-formfield">Subheading Text Colour</mat-label>
									<colour-picker formControlName="subheadingTextColour" [startTabIndex]="11"></colour-picker>
								</div>
							</div>

							<div>
								<div class="pseudo-form-field flex-layout-row flex-layout-align-space-between-center flex-layout-gap-20px">
									<mat-label class="no-formfield">Border Colour</mat-label>
									<colour-picker formControlName="borderColour" [startTabIndex]="13"></colour-picker>
								</div>
							</div>
						</div>
					</div>
					<div>
						<social-media-form-list [parentFormGroup]="dataForm" [formArray]="socialMediaArray" [startTabIndex]="14"></social-media-form-list>
					</div>
				</mat-card-content>
			</mat-card>
		</div>
		<div class="preview-width-pixels">
			<mat-card class="main-card">
				<mat-card-content>
					<booking-confirmation-design-preview-view
						[bookingConfirmationDesignId]="data.itemId"
						[eventId]="data.eventId"
						[emailBody]="emailBody.value"
						[imageUrl]="image.value"
						[socialMediaLinks]="socialMediaArray.value"
						[backgroundColour]="backgroundColour.value"
						[textColour]="textColour.value"
						[borderColour]="borderColour.value"
						[headingBackgroundColour]="headingBackgroundColour.value"
						[headingTextColour]="headingTextColour.value"
						[subheadingBackgroundColour]="subheadingBackgroundColour.value"
						[subheadingTextColour]="subheadingTextColour.value"
						[linksColour]="linksColour.value"></booking-confirmation-design-preview-view>
				</mat-card-content>
			</mat-card>
		</div>
	</div>
</div>
